// ============================================================
// WorkspaceStatusChip — the persistent status vocabulary of the
// command-center workspace: ready / active / draft-only /
// requires setup / approval required / blocked / coming later.
//
// Pass `status` and the chip resolves label + accent from the
// shared vocabulary; pass `label`/`accent` to override. `pulse`
// (or a live-ish status) adds a breathing signal dot — glow
// means live, never decoration.
// ============================================================

import { workspaceStatusMeta, tint, WORKSPACE_FONT } from './workspaceTheme'

export default function WorkspaceStatusChip({
  status = 'ready',
  label,
  accent,
  pulse,
  size = 'md',
  title,
  style: styleOverride,
}) {
  const meta = workspaceStatusMeta(status)
  const color = accent || meta.accent
  const text = label ?? meta.label
  const showPulse = pulse ?? Boolean(meta.pulse)
  const sm = size === 'sm'

  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: sm ? 5 : 6,
        padding: sm ? '2px 7px' : '3px 9px',
        borderRadius: 'var(--sc-radius-xs, 6px)',
        background: tint(color, 10),
        border: `1px solid ${tint(color, 26)}`,
        color,
        fontSize: sm ? 9 : 10,
        fontWeight: 700,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        fontFamily: WORKSPACE_FONT.mono,
        whiteSpace: 'nowrap',
        ...styleOverride,
      }}
    >
      {showPulse && (
        <span
          aria-hidden
          style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: color,
            boxShadow: `0 0 8px ${tint(color, 55)}`,
            animation: 'sc-signal-pulse 2s ease-in-out infinite',
            flexShrink: 0,
          }}
        />
      )}
      {text}
    </span>
  )
}
